import React, { Component } from "react"
import { toast, ToastContainer } from "react-toastify"
import { Container, Row, Col, Button, Table, Image, Form } from "react-bootstrap"
import { ServiceOrderedModel } from "./OrderModels"
import { FaMinus, FaPlus } from "react-icons/fa"
import PhoneNumberMaskedInput from "../FormattedInputs/PhoneNumberMaskedInput"
import SendEmailObservable from "../../api/OrderRequests/SendEmail"
import OrderReportPrintObservable from "../../api/OrderRequests/OrderReportPrint"
import OrderRequestsHeader, { StepData } from "./OrderRequestsHeader"
import OrderData, { OrderDataSSO, SSOConfig } from "../../api/OrderRequests/OrderRequestsModel/OrderData"
import { RouteComponentProps } from "react-router"
import { EmailRegexp, PhoneRegexp, StorageKey } from "../../config/Constants"
import SendMessageObservable from "../../api/OrderRequests/SendMessage"
import dotImage from "../../assets/images/dot-img.png"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import ActionButton from "../ActionButton"
import { OrderRoute, SelectionInboxRoute } from "../../config/Routes"
import ServiceType, { ServiceTypeCode } from "../../api/Administration/Model/ServiceType"
import Service, { IsServiceCodePOCT } from "../../api/Administration/Model/Service"
import { OrderFinishObservable } from "../../api/OrderRequests/OrderSubmit"
import { APIError } from "../../api/ObservableFromFetch"
import { GetSSOToken } from "../../storage/AuthToken"
import { FullBaseUrl } from "../../api/ApiUrl"
import AuthFormProcessObservable from "../../api/OrderResults/AuthForm"
import FormatError from "../../formatters/FormatError"

interface OrderFinishProps {
  isSSO?: boolean
  isFFOrder?: boolean
}

interface OrderFinishState {
  step: number
  authorizationID?: number,
  emailItems: string[]
  mobileItems: string[]
  sendingEmail: boolean
  sendingText: boolean
}

export interface FinishData {
  FormFoxTestAN: number
  ApiRequestToken: string
  BaseUrl: string
  AccountID: number
  Email: string
  SendSelectClinicLink: boolean
  MarketplaceAuthNum: string
  PersonID: number
  TestReason: string
  TestDetailIDs: number[],
  TestDetailClinicalIDs: number[]
}

export default class OrderFinish extends Component<OrderFinishProps, OrderFinishState> {
  orderObj?: OrderData = undefined
  TestDetailIDs: number[] = []
  TestDetailClinicalIDs: number[] = []
  authorizationID?: number
  servicesOrderedList: ServiceOrderedModel[] = []
  siteSelected: boolean = false

  constructor(props: OrderFinishProps) {
    super(props)

    this.getSavedOrder()

    this.state = {
      step: 3,
      authorizationID: this.authorizationID,
      emailItems: [""],
      mobileItems: [""],
      sendingEmail: false,
      sendingText: false
    }
  }

  componentWillUnmount() {
    localStorage.removeItem(StorageKey.CanViewOrderFinish)
    localStorage.removeItem(StorageKey.OrderedServices)
    localStorage.removeItem(StorageKey.OrderDonorSiteSelect)
  }

  handlePrintClick = (): void => {
    const params = {
      PersonID: this.orderObj?.PersonID,
      VendorID: this.orderObj?.VendorID,
      XMLFile: this.orderObj?.OrderXML,
      SendToEmail: false,
      EmailAddress: [],
      TestDetailIDs: this.TestDetailIDs,
      TestDetailClinicalIDs: this.TestDetailClinicalIDs
    }
    OrderReportPrintObservable(params).subscribe(
      (data) => this.print(data),
      error => toast.error(error)
    )
  }

  print(base64pdf: string) {
    const pdfWindow = window.open("")
    if (pdfWindow) {
      pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(base64pdf) + "'></iframe>")
    }
  }

  addEmail = (index: number, email: string = "") => {
    if (email !== this.state.emailItems[index]) {
      this.setState({ emailItems: [...this.state.emailItems, email] })
    }
  }

  removeEmail = (email: string, index: number) => {
    var array = [...this.state.emailItems]
    if (index > -1) {
      array.splice(index, 1)
      this.setState({ emailItems: array })
    }
  }

  changeEmail = (email: string, index: number) => {
    var array = [...this.state.emailItems]
    if (index > -1) {
      array[index] = email
      this.setState({ emailItems: array })
    }
  }

  sendEmail = () => {
    if (this.state.emailItems.filter(Boolean).length > 0) {
      if (Array.from(new Set(this.state.emailItems.map(value => value.toLowerCase()))).length !== this.state.emailItems.length) {
        toast.error("Duplicate email address is present in the list.")
        return
      }
      const params = {
        TestDetailID: this.orderObj ? this.orderObj.DrugTestDetailID > 0 ? this.orderObj.DrugTestDetailID : this.orderObj.AlcoholTestDetailID > 0 ? this.orderObj.AlcoholTestDetailID : this.orderObj.PhysicalTestDetailID > 0 ? this.orderObj.PhysicalTestDetailID : this.orderObj.POCTTestDetailID > 0 ? this.orderObj.POCTTestDetailID : 0 : 0,
        EmailAddress: this.state.emailItems,
        Message: this.orderObj?.Message || "",
        TestDetailIDs: this.TestDetailIDs,
        TestDetailClinicalIDs: this.TestDetailClinicalIDs,
        PersonID: this.orderObj?.PersonID,
        VendorID: this.orderObj?.VendorID,
        XMLFile: this.orderObj?.OrderXML
      }
      this.setState({ sendingEmail: true })
      SendEmailObservable(params).subscribe(
        (response) => toast.success(response),
        (response) => toast.error(response),
        () => this.setState({ sendingEmail: false })
      )
    }
    else {
      toast.error("Please enter email address.")
    }
  }

  isEmailValid = (value: string): boolean => {
    if (value.length === 0) {
      return true
    }
    return EmailRegexp.test(value)
  }

  canAddEmail = (email: string): boolean => email.length > 0 && this.isEmailValid(email)

  addMobile = (index: number, phone: string = "") => {
    if (phone !== this.state.mobileItems[index]) {
      this.setState({ mobileItems: [...this.state.mobileItems, phone] })
    }
  }

  removeMobile = (phone: string, index: number) => {
    var array = [...this.state.mobileItems]
    if (index > -1) {
      array.splice(index, 1)
      this.setState({ mobileItems: array })
    }
  }

  changeMobile = (phone: string, index: number) => {
    var array = [...this.state.mobileItems]
    if (index > -1) {
      array[index] = phone
      this.setState({ mobileItems: array })
    }
  }

  sendText = () => {
    if (this.state.mobileItems.filter(Boolean).length > 0) {
      if (Array.from(new Set(this.state.mobileItems.map(value => value.toLowerCase()))).length !== this.state.mobileItems.length) {
        toast.error("Duplicate mobile number is present in the list.")
        return
      }

      if (!!this.props.isSSO) {
        const params = {
          EmailAddress: this.state.mobileItems,
          FormFoxTestAN: this.state.authorizationID || 0,
          PersonID: 0,
          VendorID: 0,
          SendToEmail: false,
          SendText: true
        }
        this.setState({ sendingText: true })
        AuthFormProcessObservable(params).subscribe(
          data => toast.success("Text sent successfully"),
          error => toast.error(FormatError(error))
        )
        this.setState({ sendingText: false })
      }
      else {
        const params = {
          TestDetailID: this.orderObj?.DrugTestDetailID || this.orderObj?.AlcoholTestDetailID || this.orderObj?.PhysicalTestDetailID || this.orderObj?.POCTTestDetailID || 0,
          EmailAddress: this.state.mobileItems,
          Message: this.orderObj?.Message || "",
          TestDetailIDs: this.TestDetailIDs,
          TestDetailClinicalIDs: this.TestDetailClinicalIDs,
        }
        this.setState({ sendingText: false })
        SendMessageObservable(params).subscribe(
          () => toast.success("Text sent successfully"),
          (err) => toast.error("No data found"),
          () => this.setState({ sendingText: false })
        )
      }
    }
    else {
      toast.error("Please enter mobile number.")
    }
  }
  isPhoneValid = (value: string): boolean => value.length === 0 || PhoneRegexp.test(value)
  canAddMobile = (mobile: string): boolean => mobile.length > 0 && this.isPhoneValid(mobile)

  getSavedOrder(): void {
    const orderDonorSiteSelect = localStorage.getItem(StorageKey.OrderDonorSiteSelect) || ""
    this.siteSelected = orderDonorSiteSelect === "" || !JSON.parse(orderDonorSiteSelect)
    const data = localStorage.getItem(StorageKey.SavedOrderData)

    if (!data) {
      return
    }
    const savedOrderData: OrderData = JSON.parse(data)
    if (Array.isArray(savedOrderData)) {
        this.orderObj = savedOrderData[0]
    }
    else {
        this.orderObj = savedOrderData
    }
    if (this.orderObj) {
      if (this.orderObj.FormFoxTestAN) {
        this.authorizationID = this.orderObj.FormFoxTestAN
      }
      this.TestDetailIDs = []
      if (this.orderObj.AlcoholTestDetailIDList && this.orderObj.AlcoholTestDetailIDList.length > 0) {
        this.TestDetailIDs = this.TestDetailIDs.concat(this.orderObj.AlcoholTestDetailIDList)
      }
      if (this.orderObj.DrugTestDetailIDList && this.orderObj.DrugTestDetailIDList.length > 0) {
        this.TestDetailIDs = this.TestDetailIDs.concat(this.orderObj.DrugTestDetailIDList)
      }
      if (this.orderObj.POCTTestDetailIDList && this.orderObj.POCTTestDetailIDList.length > 0) {
        this.TestDetailIDs = this.TestDetailIDs.concat(this.orderObj.POCTTestDetailIDList)
      }
      if (this.orderObj.PhysicalTestDetailID) {
        this.TestDetailIDs.push(this.orderObj.PhysicalTestDetailID)
      }
      if (this.orderObj.ClinicalTestDetailIDList && this.orderObj.ClinicalTestDetailIDList.length > 0) {
        this.TestDetailClinicalIDs = this.TestDetailClinicalIDs.concat(this.orderObj.ClinicalTestDetailIDList)
      }
    }

    const savedServices = localStorage.getItem(StorageKey.OrderedServices)
    if (savedServices && savedServices.length) {
      this.servicesOrderedList = JSON.parse(savedServices)
    }
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  finishOrder = () => {
    const token = GetSSOToken()
    const sendLink = this.orderObj?.SendSelectClinicLink || false

    if (token != "" || sendLink) {
      const data: FinishData = {
        FormFoxTestAN: this.authorizationID || 0,
        ApiRequestToken: token,
        BaseUrl: FullBaseUrl(),
        AccountID: this.orderObj?.AccountID || 0,
        Email: this.orderObj?.Email || "",
        SendSelectClinicLink: sendLink,
        MarketplaceAuthNum: this.orderObj?.MarketplaceAuthNum?.toString() || "",
        PersonID: this.orderObj?.PersonID || 0,
        TestReason: this.orderObj?.TestReasonDescription || "",
        TestDetailIDs: this.TestDetailIDs,
        TestDetailClinicalIDs: this.TestDetailClinicalIDs
      }

      OrderFinishObservable(data).subscribe(
        data => {
          toast.success(data)
          this.returnToStart()
        },
        error => this.handleAPIError(error, {})
      )
    }
    else {
      this.returnToStart()
    }
  }

  returnToStart = () => {
    const props = this.props as RouteComponentProps
    const returnToSelectionInbox = localStorage.getItem(StorageKey.FromSelectionInbox) === "true"
    localStorage.removeItem(StorageKey.OrderedServices)
    localStorage.removeItem(StorageKey.SavedOrderData)
    localStorage.removeItem(StorageKey.FromSelectionInbox)
    props.history.push(returnToSelectionInbox ? SelectionInboxRoute : OrderRoute)
  }

  render() {
    const headerSteps: StepData[] = [{
        title: '1',
        disabled: true,
        current: this.state.step === 1,
        onClick: () => this.setState({ step: 1 })
      },{
        title: '2',
        disabled: true,
        current: this.state.step === 2,
        onClick: () => this.setState({ step: 2 })
      },{
        title: '3',
        disabled: false,
        current: this.state.step === 3,
        onClick: () => this.setState({ step: 3 })
      }
    ]

    const serviceTypesList = this.servicesOrderedList.map((service: ServiceOrderedModel) => IsServiceCodePOCT(service.serviceCode) ? "POCT" : service.serviceTypeCode)
    const serviceTypesString = serviceTypesList.filter((item, index) => serviceTypesList.indexOf(item) === index).join(', ').replace(/, ([^,]*)$/, ' AND $1')

    if (!!this.props.isFFOrder)
    return (
    <AppPageWrapper showNav={true}>
      <Container fluid className="OrderRequests grid-container">
        <Row className="pb-2"><Col>Your order has been updated.</Col></Row>
      </Container>
    </AppPageWrapper>
    )

    return (
      <AppPageWrapper showNav={true}>
        <Container fluid className="OrderRequests grid-container">
          <Row>
            <Container>
              <Row className="mb-4">
              { !this.props.isSSO && <Col><OrderRequestsHeader steps={ headerSteps } title="SERVICE ORDER FORM" /></Col>}
              </Row>
              <Row>
                <Col>
                  <h4 className="primary text-uppercase">
                    <span className="mr-2">{ serviceTypesString }</span>
                    <span>AUTHORIZATION # </span>
                    <span className="authorizationNumber"> ({ this.state.authorizationID })</span>
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col>
                  { !this.props.isSSO && <Table className="table-sm dark" responsive>
                    <thead>
                      <tr>
                        <th>SERVICE TYPE</th>
                        <th>&nbsp;</th>
                        <th>ACCOUNT</th>
                        <th>TEST TO BE PERFORMED</th>
                      </tr>
                    </thead>
                    <tbody>
                      { this.servicesOrderedList.map((service: ServiceOrderedModel, index: number) => <tr key={`service-${index}`}>
                        <td>{service.serviceTypeCode}</td>
                        <td className="text-center">
                          <Image className="" src={dotImage} hidden={service.isDOT !== true} />
                        </td>
                        <td>{service.labAccountDesc}</td>
                        <td>
                          <span>{service.testToPerformDesc}</span>
                        </td>
                      </tr>
                      )}
                      { !this.servicesOrderedList?.length && <tr><td className="pull-left" colSpan={5}>NO DATA FOUND</td></tr>}
                    </tbody>
                  </Table> }
                  {!this.props.isSSO &&  <Row className="pb-2"><Col>Count: {this.servicesOrderedList?.length}</Col></Row>}
                  {this.siteSelected && <Row className="pb-2"><Col>Your order has been placed. Please choose from the following options to send authorization form.</Col></Row>}
                  {this.siteSelected && <Row className="pb-2">
                    <Col xs={3} lg={2}>Print form:</Col>
                    <Col xs={9} lg={10} className="d-flex"><Button size="sm" className="fixed-w10" onClick={this.handlePrintClick}>Print PDF</Button></Col>
                  </Row>}
                  { this.siteSelected && this.state.emailItems.map((email, index) => <Row className="pt-2" key={ `email-${index}` }>
                      <Col xs={12} sm={3} md={3} lg={2}>
                        { index === 0 && "Email form:" }
                      </Col>
                      <Col xs={9} sm={5} md={4}>
                        <Form.Control size="sm" name="email_address" maxLength={ 40 } type="text" value={ email } onChange={ (e) => this.changeEmail(e.target.value, index) } readOnly={ this.state.emailItems.length !== index + 1 } isInvalid={ !this.isEmailValid(email) } />
                      </Col>
                      <Col xs={3} sm={4} md={5}>
                        { this.state.emailItems.length === index + 1 ? <Button size="sm" variant="primary" className="btn-sm-icon" onClick={ () => this.addEmail(index) } disabled={ !this.canAddEmail(email) }><FaPlus /></Button> : <Button size="sm" variant="primary" className="btn-sm-icon" onClick={ () => this.removeEmail(email, index) }><FaMinus /></Button> }
                      </Col>
                    </Row>
                  ) }
                  {this.siteSelected && <Row className="py-2">
                    <Col xs={12} sm={3} md={3} lg={2}></Col>
                    <Col xs={12} sm={3}><ActionButton size="sm" className="fixed-w10" onClick={ this.sendEmail } disabled={ !this.state.emailItems.every(email => this.isEmailValid(email))} spin={this.state.sendingEmail} disableOnSpin>Send Email</ActionButton></Col>
                  </Row>}
                  {this.siteSelected && this.state.mobileItems.map((mobile, index) => <Row className="pt-2" key={ `mobile-${index}` }>
                      <Col xs={12} sm={3} md={3} lg={2}>
                        { index === 0 && "Text form:" }
                      </Col>
                      <Col xs={9} sm={5} md={4}>
                        <PhoneNumberMaskedInput size="sm" value={ mobile} onChange={(value: string) => this.changeMobile(value, index)} readOnly={ this.state.mobileItems.length !== index + 1 } isInvalid={ !this.isPhoneValid(mobile) } />
                      </Col>
                      <Col xs={3} sm={4} md={5}>
                        { this.state.mobileItems.length === index + 1 ? <Button size="sm" variant="primary" className="btn-sm-icon" onClick={ () => this.addMobile(index) } disabled={ !this.canAddMobile(mobile) }><FaPlus /></Button> : <Button size="sm" variant="primary" className="btn-sm-icon" onClick={ () => this.removeMobile(mobile, index) }><FaMinus /></Button> }
                      </Col>
                    </Row>
                  ) }
                  {this.siteSelected && <Row className="pt-2">
                    <Col xs={12} sm={3} md={3} lg={2}></Col>
                    <Col xs={12} sm={3}><ActionButton size="sm" className="fixed-w10" onClick={ this.sendText } disabled={ !this.state.mobileItems.every(mobile => this.isPhoneValid(mobile)) } spin={this.state.sendingText} disableOnSpin>Send Text</ActionButton></Col>
                  </Row>}
                  <Row className="py-2">
                  {!this.props.isSSO && <Col><Button size="sm" onClick={this.finishOrder} variant="primary" className="fixed-w10 float-left">FINISH</Button></Col>}
                  </Row>
                </Col>
              </Row>
            </Container>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4} className="pt-2">
            </Col>
          </Row>
        </Container>
      </AppPageWrapper>
    )
  }
}
